import clsx from 'clsx'

import s from './Loader.module.scss'
import type { LoaderProps } from './Loader.props'

export function Loader({ className }: LoaderProps) {
  return (
    <div
      className={clsx(s.loader, className)}
      aria-label="Loader"
    />
  )
}
